import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  IrrigationEngine,
  BuildingHeat,
  WaterHeating,
  PowerGenerator,
  FlameWeeding
} from './equipmentSurveys';
import globalLoader from '../../../site/global-loader';

const equipmentOptions = {
  IrrigationEngine: 'Engines - Irrigation Engine',
  BuildingHeat: 'Building Heating - Building Heating System',
  WaterHeating: 'Water Heating - Water Heating System',
  PowerGenerator: 'Generators - Power Generator',
  FlameWeeding: 'Flame Weeding - Tractor Pulled or Push type'
};

function AddEquipment() {
  // get equipment type from URL
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop)
  });
  let equipment = params.equipment ? params.equipment : '';

  // state
  const [disabledOptions, setDisabledOptions] = useState([]);
  const [applicationData, setApplicationData] = useState({});
  const [selectedEquipment, setSelectedEquipment] = useState(equipment);
  const [loading, setLoading] = useState(true);

  // Render Application
  const renderApplication = (selectedEquipment) => {
    const equipmentTypes = {
      IrrigationEngine,
      BuildingHeat,
      WaterHeating,
      PowerGenerator,
      FlameWeeding
    };
    const Application = equipmentTypes[selectedEquipment];
    return (
      <Application
        applicationData={applicationData}
        setApplicationData={setApplicationData}
      />
    );
  };

  // Grab data on initial load
  useEffect(() => {
    globalLoader.show();

    axios
      .post(window.wlPipConfig.ajaxUrl + '?action=wl_fip_get_application_data')
      .then((res) => {
        setApplicationData(res.data.data);
        setLoading(false);
        globalLoader.hide();
      })
      .catch((err) => {
        setErrors(err.response.data.data);
        globalLoader.hide();
      });
  }, []);

  useEffect(() => {
    if (applicationData.equipment_counts) {
      let options = Object.keys(equipmentOptions).filter(
        (type) => applicationData.equipment_counts[type] >= 2
      );
      setDisabledOptions(options);
    }
  }, [applicationData]);

  return (
    <div>
      <div className="form__field">
        <div className="form__select form__select--lg">
          <select
            onChange={(event) => setSelectedEquipment(event.target.value)}
            defaultValue={selectedEquipment}
            disabled={(loading || applicationData.aid) && 'disabled'}
          >
            <option value="">-- Please select equipment type --</option>
            {Object.entries(equipmentOptions).map((type) => {
              let disabled = disabledOptions.includes(type[0]);
              return (
                <option
                  key={type[0]}
                  value={type[0]}
                  disabled={disabled ? 'disabled' : ''}
                >
                  {`${type[1]} ${
                    disabled ? ' -- Annual limit reached (2 per year)' : ''
                  }`}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      {selectedEquipment ? (
        renderApplication(selectedEquipment)
      ) : (
        <p>
          <b>Selected Equipment:</b> {selectedEquipment}
        </p>
      )}
    </div>
  );
}

export default AddEquipment;
